// extracted by mini-css-extract-plugin
export default {"melodyVideo":"TM-z","isFullWidth":"UM-z","landingPageVideo":"VM-z","play":"WM-z","iframeVideo":"XM-z","playHidden":"YM-z","fullwidth":"ZM-z"};